/** @format */

import React, { ChangeEvent, useEffect, useState } from 'react';
import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel } from '@material-ui/core';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import I18n from '../../../components/Translate/I18n';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import { useDispatch, useSelector } from 'react-redux';
import {
    PlatformIccidMsisdnIpPoolReducerAction,
    PlatformIccidMsisdnIpPoolReducerType,
} from '../../../modules/iccid/PlatformIccidMsisdnIpPoolReducer';
import CustomInputExt from '../../../components/CustomInput/CustomInputExt';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { apiShortPlatformImsiRange } from '../../../interfaces/collections/PlatformIccidRmoHistory';
import { PlatformImsiRange, PlatformImsiRangeResponse } from '../../../interfaces/platform/PlatformImsiRange';
import Filter from '../../../interfaces/forms/Filter';
import { HeaderCheckBoxSelectListElement } from '../../lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { StoreStackReducerType } from '../../../modules/lib/StoreStackReducer';
import { PlatformRmoType } from '../../../interfaces/collections/PliCbd2CollectionInterface';
import i18next from 'i18next';

const _ = require('underscore');

export type PlatformImsiRangeParam = {
    rmoPartner: number | null;
    rmoMvne: number | null;
    rmoPartnerSelected: number | null;
    rmoMvneSelected: number | null;
};

export const ImsiChangeRmoTypeAdvance = (): React.ReactElement => {
    const dispatch = useDispatch();
    const { openChangeIndicateRangeAdv, selectedValue, type } = useSelector(
        (state: { platformIccidMsisdnIpPoolReducer: PlatformIccidMsisdnIpPoolReducerType }) => state.platformIccidMsisdnIpPoolReducer
    );
    const { platformRmoCollection } = useSelector((state: { storeStackReducer: StoreStackReducerType }) => state.storeStackReducer);

    const [open, setOpen] = useState(false);
    const [fromImsi, setFromImsi] = useState<string | null>(null);
    const [toImsi, setToImsi] = useState<string | null>(null);
    const [totalCard, setTotalCard] = useState(0);
    const [selectRmoPartner, setSelectRmoPartner] = useState<Array<HeaderCheckBoxSelectListElement>>([]);
    const [selectRmoMvne, setSelectRmoMvne] = useState<Array<HeaderCheckBoxSelectListElement>>([]);
    const [rmoParams, setRmoParams] = useState({ rmoPartner: null, rmoMvne: null } as PlatformImsiRangeParam);

    useEffect(() => {
        if (
            type === PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_MVNE_CHANGE ||
            type === PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_PARTNER_CHANGE
        ) {
            const newParams = _.clone(rmoParams);
            if (type === PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_MVNE_CHANGE) {
                newParams.rmoMvneSelected = selectedValue;
            }
            if (type === PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_PARTNER_CHANGE) {
                newParams.rmoPartnerSelected = selectedValue;
            }
            if (newParams.rmoMvneSelected !== rmoParams.rmoMvneSelected || newParams.rmoPartnerSelected !== rmoParams.rmoPartnerSelected) {
                setRmoParams(newParams);
            }
        }
    }, [selectedValue, type, rmoParams]);

    useEffect(() => {
        if (platformRmoCollection?.['hydra:member']) {
            const selectMvne: Array<HeaderCheckBoxSelectListElement> = [];
            const selectPartner: Array<HeaderCheckBoxSelectListElement> = [];
            for (let i = 0; i < platformRmoCollection['hydra:member'].length; i++) {
                const model = platformRmoCollection['hydra:member'][i];
                if (model.rmoType === PlatformRmoType.MVNE) {
                    selectMvne.push({ name: model.description, value: model.id });
                }
                if (model.rmoType === PlatformRmoType.PARTNER) {
                    selectPartner.push({ name: model.description, value: model.id });
                }
            }
            setSelectRmoMvne(selectMvne);
            setSelectRmoPartner(selectPartner);
        }
    }, [platformRmoCollection]);

    useEffect(() => {
        setOpen(openChangeIndicateRangeAdv ?? false);
    }, [openChangeIndicateRangeAdv]);

    useEffect(() => {
        if ((fromImsi && fromImsi.length > 0) || (toImsi && toImsi.length > 0)) {
            const itemLoader = new ItemLoaders(dispatch);
            const filters: Array<Filter> = [];
            if (fromImsi && fromImsi.length > 0) {
                filters.push({ name: 'fromImsi', value: fromImsi });
            }
            if (toImsi && toImsi.length > 0) {
                filters.push({ name: 'toImsi', value: toImsi });
            }
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/' + apiShortPlatformImsiRange)),
                PlatformIccidMsisdnIpPoolReducerAction.RMO_CHANGE_OPEN_DIALOG_ADVANCED_RANGE_COUNTER,
                filters,
                [],
                (data: PlatformImsiRangeResponse): void => {
                    setTotalCard(data.rangeCount);
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [dispatch, fromImsi, toImsi]);

    const updateParams = (e: ChangeEvent<HTMLInputElement>): void => {
        const value = parseInt(e.target.value);
        const checked = e.target.checked;
        const newParams = _.clone(rmoParams);
        if (value === 1 && checked) {
            newParams.rmoMvne = value;
        }
        if (value === 1 && !checked) {
            newParams.rmoMvne = null;
        }
        if (value === 2 && checked) {
            newParams.rmoPartner = value;
        }
        if (value === 2 && !checked) {
            newParams.rmoPartner = null;
        }
        setRmoParams(newParams);
    };

    const closeCallback = (): void => {
        dispatch({
            type: PlatformIccidMsisdnIpPoolReducerAction.INDICATED_RANGE_CHANGE_OPEN_DIALOG_ADVANCED,
            openChangeIndicateRangeAdv: false,
        } as PlatformIccidMsisdnIpPoolReducerType);
    };

    const couterCallback = (): void => {};

    const confirmCallback = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.putWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/' + apiShortPlatformImsiRange + '/-1')),
            'change_indicated_range_model_call_api',
            {
                fromImsi: fromImsi,
                toImsi: toImsi ?? fromImsi,
                params: JSON.stringify(rmoParams),
            } as PlatformImsiRange,
            (data: PlatformImsiRangeResponse) => {
                dispatch({ type: PlatformIccidMsisdnIpPoolReducerAction.INDICATED_RANGE_RELOAD_MAIN_LIST_AFTER_CHANGE });
                closeCallback();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    return (
        <Dialog open={open} onClose={closeCallback} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <I18n trans="pools:sim.change_indicated_range" />
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={6}>
                        <CustomInputExt
                            labelText="pools:sim.range_from_imsi"
                            onChange={(event: React.FormEvent<HTMLInputElement>): void => {
                                setFromImsi(event.currentTarget.value);
                            }}
                            value={fromImsi}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <CustomInputExt
                            labelText="pools:sim.range_to_imsi"
                            onChange={(event: React.FormEvent<HTMLInputElement>): void => {
                                setToImsi(event.currentTarget.value);
                            }}
                            value={toImsi}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <FormControlLabel
                            control={<Checkbox value={1} onChange={updateParams} />}
                            label={i18next.t('pools:sim.set_if_change_rmo_mvne')}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <FormControlLabel
                            control={<Checkbox value={2} onChange={updateParams} />}
                            label={i18next.t('pools:sim.set_if_change_rmo_partner')}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <SimpleSelect
                            dispatchName={PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_MVNE_CHANGE}
                            label="pools:pool.mvne_status_rmo"
                            required={false}
                            elements={selectRmoMvne}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <SimpleSelect
                            dispatchName={PlatformIccidMsisdnIpPoolReducerAction.RMO_MODEL_PARTNER_CHANGE}
                            label="pools:pool.partner_status_rmo"
                            required={false}
                            elements={selectRmoPartner}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <div style={{ marginTop: '20px' }}>
                            <I18n trans="pools:sim.total_card" valueObject={{ count: totalCard }} />
                        </div>
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={closeCallback} callbackParam={{}} label="general:common.close" size="sm" />
                {(rmoParams.rmoPartner !== null || rmoParams.rmoMvne !== null) && fromImsi && (
                    <CustomTextButtom
                        callback={confirmCallback}
                        callbackParam={{}}
                        label="pools:sim.confirm_dialog_change_indicated_range_title"
                        size="sm"
                    />
                )}
            </DialogActions>
        </Dialog>
    );
};
